// 管理员管理
import http from "@/jslibs/axios/http";

// 新增管理员
export const add = (data) => http.post("/web/permissionManager/addAccount", data);

// 编辑管理员
export const edit = (data) => http.post("/web/permissionManager/editAccount", data);

// 管理员详情
export const detail = (data) => http.post("/web/permissionManager/getAccountInfoDetail", data);

// 管理员分页列表
export const page = (data) => http.post("/web/permissionManager/getAccountList", data);

// 管理员删除
export const del = (data) => http.post("/web/permissionManager/deleteAccount", data);

// 管理员导出
export const _export = (data) => http.post("/web/permissionManager/exportAccountList", data, { responseType: "blob" });

// 修改密码
export const updatePassword = (data) => http.post("/web/permissionManager/updatePassword", data);
